/**
 * 图片上传服务
 * 使用后端签发的短时效 Blob 级 SAS 直传图片。
 */
import { api, API_PATHS } from './client';

export type SettingsImageField = 'logo' | 'banner';

interface AzureUploadSASData {
  uploadUrl: string;
  blobUrl: string;
  blobName: string;
  expiresAt: string;
}

export async function getAzureUploadSAS(
  field: SettingsImageField,
  fileName: string
): Promise<AzureUploadSASData> {
  return api.post<AzureUploadSASData>(API_PATHS.TOOL_AZURE_CREATE_SAS, {
    field,
    fileName,
  });
}

export async function uploadSettingsImage(
  file: File,
  field: SettingsImageField
): Promise<string> {
  const { BlockBlobClient } = await import('@azure/storage-blob');
  const { uploadUrl, blobUrl } = await getAzureUploadSAS(field, file.name);
  const blockBlobClient = new BlockBlobClient(uploadUrl);

  await blockBlobClient.uploadData(file, {
    blobHTTPHeaders: {
      blobContentType: file.type || 'application/octet-stream',
    },
  });

  return blobUrl;
}
